import styled from "styled-components";


export const ContainerInformations = styled.div `
display: flex;
flex-direction: row-reverse;

@media screen and (max-width: 1425px){
    margin: 20px;
}

@media screen and (max-width: 975px){
        flex-direction: column;
}
`;